import { render, staticRenderFns } from "./MarginCustoms.vue?vue&type=template&id=a6123a4e"
import script from "./MarginCustoms.vue?vue&type=script&lang=js"
export * from "./MarginCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports